import exenv from 'exenv';
import type {RouterHistory} from 'src/rerouter/index';
import {BrowserHistory, ServerHistory} from 'src/rerouter/index';

/**
 * NOTE (kyle): Wherever possible, use `useHistory` instead of this singleton.
 * It will be difficult to refactor any code that uses it in the future. Plus
 * the ServerHistory is mostly a noop.
 */
export const browserHistory: RouterHistory = exenv.canUseDOM
  ? new BrowserHistory()
  : new ServerHistory();
